import { CreditPortfolio } from './credit-portfolio.model'
import { CreditCalculationStructure, CreditStructure } from './credit-structure.model'
import {
  CreditSubmissionReinsurerStatus,
  CreditSubmissionUserTrancheStatus,
} from './credit-submission.model'

export enum GseSubmissionStatus {
  Draft = 'Draft',
  Final = 'Final',
  Approved = 'Approved',
  Released = 'Released',
  Cancelled = 'Cancelled',
  Deleted = 'Deleted',
}

export enum GseSubmissionSubStatus {
  ApprovalPending = 'Approval Pending',
  ClientRejected = 'Client Rejected',
}

export interface GseSubmissionStructure {
  id?: number
  gse_structure_id: number
  gse_submission_structure_id: string
  program_id: number
  label: string
  description: string
  transaction_id: string
  status: GseSubmissionStatus
  selected_gls?: string
  portfolio_id?: string
  doc_link?: string
  approved_by?: string
  approved_at?: string
  sub_status?: GseSubmissionSubStatus
  comments?: string
  reinsurer_ids?: number[]
  removed_reinsurers?: number[]
  carrier_id?: number
  carrier_name?: string
  carrier_year_id?: number
  // UI-only
  imageSrc?: string
  year?: number
  audit_insert_dt?: string
  client_id?: number
}

export interface GseSubmissionReinsurer {
  id: number
  gse_submission_id: number
  reinsurer_id: number
  status: CreditSubmissionReinsurerStatus
  viewed_by: string
  viewed_at: string
}

export interface GseSubmissionUserTranche {
  id?: number
  gse_submission_id: number
  user_id: number
  tranche_id: string
  rol: number
  reinsurer_participation_percent: number
  collateral_percent: number
  ceding_commission: number
  profit_commission: number
  margin: number
  status: CreditSubmissionUserTrancheStatus
  rorac_scenario: string
}

export interface CreateGseSubmissionDraftProps {
  portfolio: CreditPortfolio
  creditStructure: CreditStructure
  calculationStructure: CreditCalculationStructure
  transactionId: string
  description: string
}
